import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { Router, Route } from "react-router-dom";
import history from "./helpers/history";
import store from "./store";
import { toast } from "react-toastify";
import { RootContainer } from "./RootContainer.jsx";
import { initLogger } from "services/logger";
import { queryClient } from "./queryClient";

toast.configure({
  autoClose: false,
  hideProgressBar: true,
  className: "custom-toast-error",
  toastClassName: "custom-toast",
});

initLogger();

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <Route
          render={({ location }) => {
            return <RootContainer location={location} />;
          }}
        />
      </Router>
    </QueryClientProvider>
  </Provider>,
);
